<template>

    <div>
        <v-file-input
            v-model="model"
            :counter="counter"
            :label="label"
            :multiple="multiple"
            :accept="accept"
            placeholder="Selecione os arquivos"
            :outlined="outlined"
            :show-size="1000"
            @change="handleFileChange"
            :name="name"
            :error="error"
            :rules="resolvedRules"
        >
            <template v-slot:selection="{ index, text }">
                <v-chip
                    v-if="index < 2"
                    outlined
                    label
                    small
                    color="grey grey--text text--darken-3"
                >
                    {{ text }}
                </v-chip>
                
                <span
                v-else-if="index === 2"
                class="text-overline grey--text text--darken-3 mx-2"
                >
                +{{ model.length - 2 }} Arquivo(s)
                </span>
      </template>
    </v-file-input>

        <!-- <div v-if="selectedFiles" v-for="(item, i) in selectedFiles" :key="i">
            <p>Nome do arquivo: {{ item.name }}</p>
            <p>Tipo do arquivo: {{ item.type }}</p>
            <p>Tamanho do arquivo: {{ item.size }} bytes</p>
        </div> -->
    </div> 
  </template>

<script>
export default {
    name: "EmcFormFile",
    data: () => ({
        files: [],
        selectedFiles: null,
    }),
    props: {
        label: { type: String, default: "Anexo" },
        outlined: { type: Boolean, required: false },
        multiple: { type: Boolean, required: false },
        counter: { type: Boolean, default: true },
        accept: { type: String, default: null },
        // Mantem compatibilidade com a regra antiga (2MB).
        // Se precisar, pode ser sobrescrito pelo pai.
        maxSizeBytes: { type: Number, default: 2000000 },
        rules: { type: Array, default: null },
        value: { type: [String, Number, Object, Array] },
        name: { type: String, default: "file" },
        error: { type: Boolean, required: false }
    },
    computed: {
        resolvedRules() {
            if (Array.isArray(this.rules)) return this.rules

            const normalizeToArray = (value) => {
                if (!value) return []
                if (Array.isArray(value)) return value
                if (typeof FileList !== 'undefined' && value instanceof FileList) return Array.from(value)
                return [value]
            }

            const max = Number(this.maxSizeBytes)
            if (!max || isNaN(max) || max <= 0) return []

            return [
                (value) => {
                    const arr = normalizeToArray(value)
                    if (arr.length === 0) return true

                    const invalid = arr.find((f) => f && typeof f.size === 'number' && f.size > max)
                    if (!invalid) return true

                    const maxMb = (max / (1024 * 1024)).toFixed(0)
                    return `O arquivo precisar ter no maximo ${maxMb} MB!`
                }
            ]
        },
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        handleFileChange(files) {
        // v-file-input pode retornar File, [File] ou FileList dependendo das props.
        const normalizeToArray = (value) => {
            if (!value) return []
            if (Array.isArray(value)) return value
            if (typeof FileList !== 'undefined' && value instanceof FileList) return Array.from(value)
            return [value]
        }

        const arr = normalizeToArray(files)
        this.selectedFiles = arr.length > 0 ? arr : null
    }
  }
}
</script>
